import React from "react";

export default function Footer() {
    return (
        <div className="w-full text-center py-3 border-t border-white/[0.04]">
            <p className="text-[10px] text-slate-600 font-medium">
                QueryTel Sentinel · Agentic SOC Platform v5.0
            </p>
        </div>
    );
}
